import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ConfiguracionFirmasDibujadaTrazadoComponent } from '../configuracion-firmas-dibujada-trazado/configuracion-firmas-dibujada-trazado.component';

import { FormArray, FormGroup } from '@angular/forms';

import { MatSnackBar } from '@angular/material/snack-bar';

import { Subscription } from 'rxjs';

import { FirmanteNif, TipoFirma } from '../../../models/firmante-nif';

import { DatosConfiguracionDocumentosService } from '../../../services/datos-configuracion-documentos.service';

import { FormularioDocumentoService } from '../../../services/formulario-documento.service';
import { resumenFirmaTarjeta } from '../../../services/resumen-firma-tarjeta';



@Component({

  selector: 'app-configuracion-firmas-tipo-firmantes',

  templateUrl: './configuracion-firmas-tipo-firmantes.component.html',

  styleUrls: ['./configuracion-firmas-tipo-firmantes.component.css']

})

export class ConfiguracionFirmasTipoFirmantesComponent implements OnInit, OnDestroy {



  @Input() firmante: any;

  @Input() isEstado: boolean = false;

  @Input() inlineMode = false;

  @ViewChild('trazadoCmp') trazadoComponent?: ConfiguracionFirmasDibujadaTrazadoComponent;

  indexFirma: number = 1;

  @Output() firmanteSeleccionado: EventEmitter<FirmanteNif> = new EventEmitter<FirmanteNif>()

  tipoFirmaAnterior: TipoFirma;

  tieneTagAnterior: boolean;

  tipoFirmaAnteriorArray: TipoFirma;

  isAtras: boolean = false;
  mostrarErrorEmplazamiento = false;

  private tipoFirmaSubscription: Subscription;

  private abrirFirmantePanelSubscription: Subscription;



  constructor(public formularioDocumentoService: FormularioDocumentoService,

              private _snackBar: MatSnackBar,

              private datosConfiguracionDocumentosService: DatosConfiguracionDocumentosService) { }



  ngOnInit(): void {

    this.indexFirma = this.formularioDocumentoService.getIndexFirmaPanel(this.firmante.tipoFirmante.codigo);

    if (!this.formFirma || !this.tipoFirma || !this.tieneTag) {
      return;
    }

    this.tipoFirmaAnterior = this.tipoFirma.value;

    this.tieneTagAnterior = this.tieneTag.value;

    this.datosConfiguracionDocumentosService.transferirTipoFirma(this.getTipoFirmaConFirmanteAnterior());

    this.tipoFirmaSubscription = this.tipoFirma.valueChanges.subscribe((nuevoTipo: TipoFirma) => {

      this.onTipoFirmaChanged(nuevoTipo);

    });

    this.abrirFirmantePanelSubscription = this.datosConfiguracionDocumentosService.datosAbrirFirmantePanel$.subscribe(

      (codigo) => {

        if (codigo === this.firmante.tipoFirmante.codigo) {

          this.indexFirma = this.formularioDocumentoService.getIndexFirmaPanel(codigo);

        }

      }

    );

  }



  ngOnDestroy(): void {

    this.tipoFirmaSubscription?.unsubscribe();

    this.abrirFirmantePanelSubscription?.unsubscribe();

  }



  private irAIndexFirma(nuevoIndex: number): void {

    this.mostrarErrorEmplazamiento = false;

    this.indexFirma = nuevoIndex;

    this.formularioDocumentoService.setIndexFirmaPanel(this.firmante.tipoFirmante.codigo, nuevoIndex);

  }



  private onTipoFirmaChanged(nuevoTipo: TipoFirma): void {

    if (this.tipoFirmaAnterior === nuevoTipo) {

      return;

    }

    const tipoAnterior = this.tipoFirmaAnterior;

    this.tipoFirmaAnterior = nuevoTipo;

    this.formularioDocumentoService.clearFirmasPdfOnTipoChange(

      this.firmante.tipoFirmante.codigo,

      tipoAnterior,

      nuevoTipo

    );

    if (nuevoTipo === TipoFirma.Validador) {
      this.formularioDocumentoService.clearFormulariosYCamposOnValidador(
        this.firmante.tipoFirmante.codigo
      );
    }

    this.resetFirmasExceptTipoFirma();

    this.tieneTagAnterior = this.tieneTag.value;

    this.datosConfiguracionDocumentosService.transferirTipoFirma(this.getTipoFirmaConFirmanteAnterior());
    this.datosConfiguracionDocumentosService.transferirDatosValidador(true);

  }



  private resetFirmasExceptTipoFirma(): void {
    if (!this.formFirma || !this.posicionFirmas) {
      return;
    }

    Object.keys(this.formFirma.controls).forEach(key => {

      if (key !== 'tipoFirma') {

        this.formFirma.controls[key].reset(undefined, { emitEvent: false });

      }

    });

    while (this.posicionFirmas.length > 0) {

      this.posicionFirmas.removeAt(0, { emitEvent: false });

    }

  }



  // si hay errores, hacemos que el firmante se abra por el paso donde hay el error. Añadimos isAtras para que nos deje tirar para atrás y no contemple el error.

  ngDoCheck(){

    if(this.firmante.tipoErrorFirma=='validadoresTipoFirmaRequired' && this.tipoFirma?.value == null) this.irAIndexFirma(1);

    if(this.firmante.tipoErrorFirma=='validadoresTagRequired' && this.tieneTag?.value == null && this.isAtras==false) this.irAIndexFirma(2);

    if(this.firmante.tipoErrorFirma=='validadoresNombreTagRequired' && (this.nombreTag?.value == null || this.nombreTag?.value == '') && this.isAtras==false) this.irAIndexFirma(4);

    if(this.firmante.tipoErrorFirma=='validadoresPosicionFirmasRequired' && (this.posicionFirmas?.length ?? 0)==0 && this.isAtras==false) this.irAIndexFirma(3);

  }



  //obtenemos los valores de tipoFirma para cada firmante al momento de cargar y se lo pasamos al componente configuracion-documento-page para que chequee si el usuario ha cambiado el tipoFirma.

  getTipoFirmaConFirmanteAnterior(){

    let tipoFirmaConFirmanteArray: any[] = [];

    this.formularioDocumentoService.firmantesNif.value.forEach((x: FirmanteNif) => {

      let objetoFirmaConFirmante: any;

      objetoFirmaConFirmante ={

        tipoFirmante: x.tipoFirmante,

        tipoFirma: x.firmas.tipoFirma,

        tieneTag: x.firmas.tieneTag

      }

      tipoFirmaConFirmanteArray.push(objetoFirmaConFirmante)

    })

    return tipoFirmaConFirmanteArray

  }





  get formFirma(): FormGroup | null {
    return this.formularioDocumentoService.getFirmasGroup(this.firmante.tipoFirmante.codigo);
  }



  get tipoFirma(){ return this.formFirma?.get('tipoFirma') ?? null }



  get tieneTag(){ return this.formFirma?.get('tieneTag') ?? null }



  get nombreTag(){ return this.formFirma?.get('nombreTag') ?? null }



  get nombreCertificado(){ return this.formFirma?.get('nombreCertificado') ?? null }



  get posicionFirmas(){ return this.formFirma?.get('posicionFirmas') as FormArray | null }



  //mandamos el estado al padre (configuracion-documento-configurar-firma) para que gestione abrir/cerrar el firmante seleccionado.

  mostrarEstado(firmanteNuevo: FirmanteNif){
    const abriendo = !this.firmante.seleccionado;
    this.firmanteSeleccionado.emit(firmanteNuevo);
    if (abriendo) {
      this.isAtras = false;
      delete this.firmante.tipoErrorFirma;
      this.irAIndexFirma(1);
    }
  }



  siguiente(){

    this.isAtras=false;

    if(this.indexFirma==1){

      if(this.tipoFirma.value == TipoFirma.Dibujada) this.irAIndexFirma(2);

      else if(this.tipoFirma.value == TipoFirma.Certificado) {

        this.irAIndexFirma(5);

      } else {
        this.mostrarErrorSeleccionFirma('validadoresTipoFirmaRequired');
        this._snackBar.open('Seleccione una opción para continuar.', 'Cerrar', {duration: 3000});
      }

    }else if(this.indexFirma==2){

      //si tieneTag ha cambiado su valor, reseteamos las siguientes opciones para añadir las nuevas.

      if(this.tieneTagAnterior !== this.tieneTag.value){

        this.nombreTag.reset();

        while (this.posicionFirmas.length > 0) this.posicionFirmas.removeAt(0);

        this.datosConfiguracionDocumentosService.transferirArrayFirmasVacio(this.firmante.tipoFirmante);

      }

      if(this.tieneTag.value == false) this.irAIndexFirma(3);

      else if(this.tieneTag.value == true) this.irAIndexFirma(4);

      else {
        this.mostrarErrorSeleccionFirma('validadoresTagRequired');
        this._snackBar.open('Seleccione una opción para continuar.', 'Cerrar', {duration: 3000});
      }

    }else if(this.indexFirma==5){

      this.nombreCertificado?.setErrors(null);

      this.irAIndexFirma(2);

    }

    this.tieneTagAnterior = this.tieneTag.value;

  }

  private mostrarErrorSeleccionFirma(
    errorKey: 'validadoresTipoFirmaRequired' | 'validadoresTagRequired'
  ): void {
    if (!this.formFirma) {
      return;
    }
    this.formularioDocumentoService.indexPaso = 9;
    if (errorKey === 'validadoresTagRequired') {
      this.mostrarErrorEmplazamiento = true;
    } else {
      this.formFirma.markAllAsTouched();
    }
    this.formFirma.updateValueAndValidity();
    if (!this.formFirma.hasError(errorKey)) {
      this.formFirma.setErrors({ ...(this.formFirma.errors ?? {}), [errorKey]: true });
    }
  }



  puedeColocarEnPdf(): boolean {
    const tipo = this.tipoFirma?.value;
    if (tipo !== TipoFirma.Dibujada && tipo !== TipoFirma.Certificado) {
      return false;
    }
    if (this.tieneTag?.value !== false) {
      return false;
    }
    return this.indexFirma >= 3;
  }

  getResumenFirma(): string {
    return resumenFirmaTarjeta({
      tipo: this.tipoFirma?.value,
      tieneTag: this.tieneTag?.value,
      nombreTag: this.nombreTag?.value,
      posicionFirmasCount: this.posicionFirmas?.length ?? 0,
    });
  }

  iniciarColocacionFirma(): void {
    if (!this.puedeColocarEnPdf()) {
      return;
    }
    this.trazadoComponent?.getPosicion({});
  }

  atras(){

    this.isAtras = true;

    delete this.firmante.tipoErrorFirma; //si hay un error lo borramos para que no se solape con la nueva info que añadimos.

    if(this.indexFirma==5) {
      // No resetear tipoFirma: valueChanges borraría nombreCertificado vía resetFirmasExceptTipoFirma
      this.irAIndexFirma(1);
      this.isAtras = false;
    }

    if(this.indexFirma==2){

      if(this.tipoFirma.value == TipoFirma.Certificado){

        this.irAIndexFirma(5);

        this.isAtras = false;

      }else{

        this.formularioDocumentoService.deleteCampoFirma(this.firmante.tipoFirmante, 'tipoFirma');

        this.irAIndexFirma(1);

        this.isAtras = false;

      }

    }

    if(this.indexFirma==3 || this.indexFirma==4){

      this.formularioDocumentoService.deleteCampoFirma(this.firmante.tipoFirmante, 'tieneTag');

      this.irAIndexFirma(2);

    }

  }



}


